import 'sanitize.css';
import 'sanitize.css/forms.css';
import 'sanitize.css/typography.css';
import Config from './config';

const container = document.getElementById('root');
if (container === null) {
    throw new Error('Root container #root was not found in the document.');
}

// The site is two former XOOPS installations: the portal at the document root
// and the XooNIps database under /researchers. Each has its own theme, and the
// two stylesheets style the same selectors (body, #header, #main, ...), so only
// one half is ever loaded into a page. Links between the halves are plain
// anchors, which load the other half from scratch.
const isResearchers = (pathname: string): boolean =>
    pathname === Config.RESEARCHERS_URL || pathname.startsWith(`${Config.RESEARCHERS_URL}/`);

const start = isResearchers(window.location.pathname)
    ? import('./researchers/start').then((module) => module.default(container))
    : import('./front/start').then((module) => module.default(container));

start.catch((error: unknown) => {
    console.error('failed to load the site data', error);
    container.textContent = 'Failed to load the site data.';
});
